const options = {
  5: "bg-green-200/5",
  10: "bg-green-200/10",
  25: "bg-green-200/25",
  50: "bg-green-200/50",
  75: "bg-green-200/75",
  90: "bg-green-200/90",
  100: "bg-green-200",
};

const from = {
  5: "from-green-200/5",
  10: "from-green-200/10",
  25: "from-green-200/25",
  50: "from-green-200/50",
  75: "from-green-200/75",
  90: "from-green-200/90",
  100: "from-green-200",
};

export default function getBackgroundGreen200(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
